
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand-partnerships",
      function () {
        return require("private-next-pages/brand-partnerships.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand-partnerships"])
      });
    }
  